var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 16,
    height: 16,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-User_Rights"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_Rights",
    "data-name": "User Rights",
    clipPath: "url(#clip-User_Rights)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3309",
    "data-name": "Group 3309",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16870",
    "data-name": "Group 16870",
    transform: "translate(1 -1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M13.678,22.314a3.218,3.218,0,0,1-3.009,1.732,4.027,4.027,0,0,1-3.111-1.638A4.558,4.558,0,0,1,6.627,19.9,2.337,2.337,0,0,1,7.242,18.1a1.439,1.439,0,0,1,.726-.357V12.958a1.079,1.079,0,0,1,.32-.77A.969.969,0,0,1,9,11.909a1.044,1.044,0,0,1,.972,1.066V15.72a.963.963,0,0,1,.446-.109,1.027,1.027,0,0,1,1,1.046.956.956,0,0,1,.447-.111,1.027,1.027,0,0,1,1,1.044.961.961,0,0,1,.447-.111,1.027,1.027,0,0,1,1,1.05.23.23,0,0,1,0,.027l-.183,1.894",
    transform: "translate(-3.037 -6.947)",
    fill: "none",
    stroke: "#505050",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M6.688,10.2a2.53,2.53,0,1,1,4.078.133",
    transform: "translate(-2.755 -2.755)",
    fill: "none",
    stroke: "#505050",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M2.315,7.808A3.892,3.892,0,1,1,7.8,7.482",
    transform: "translate(1.129 1.129)",
    fill: "none",
    stroke: "#505050",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRights);
export default __webpack_public_path__ + "static/media/User Rights.36e9ee09c1098506563477385ca68ef4.svg";
export { ForwardRef as ReactComponent };